export function getIsSeatAvailableByFilters(filters) {
    return (seat) => {
        var _a;
        if (!((_a = seat.restrictions) === null || _a === void 0 ? void 0 : _a.length) || !filters.length) {
            return seat;
        }
        const isIncludeFilter = !seat.restrictions.some(restriction => filters.includes(restriction));
        return Object.assign(Object.assign({}, seat), { isAvailable: seat.isAvailable && isIncludeFilter });
    };
}
